<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Listes syndicales</p>
        <p class="no-margin dark-gray">Créez et configurez les listes syndicales pour ce scrutin.</p>
      </div>
    </div>
  </div>

  <app-union-table *ngIf="unions.length > 0" [(unions)]="unions" [colleges]="colleges" (removeUnion)="removeUnion($event)"
    [areUnionsValidated]="unionValidatedEvent"></app-union-table>


  <div id="poll-title" class="p-20">
    <div *ngIf="!unionValidatedEvent">
      <div class="flex flex-column gap-10 align-items-center content-center p-20 radius-10 pointer" (click)="addList()"
        style="border: dashed 1px #1990FF;">
        <p class="light-blue no-margin"><span class="bold">+</span> Ajouter une liste syndicale</p>
      </div>
    </div>
    <div *ngIf="unions.length > 0">
      <div *ngIf="unionValidatedEvent === false" class="mt-20">
        <p class="dark-blue text-center">
          <span class="bold">Une fois validées, </span>les listes seront figées et vous pourrez ajouter les candidats.
        </p>
        <div class="flex content-end">
          <v8te-active-button [buttonText]="'Valider les listes syndicales'" [primaryColor]="'#63BA67'"
            [border]="'none'" (click)="validateUnions()"></v8te-active-button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="unionValidatedEvent">
  <app-college-candidates *ngFor="let college of colleges; let i = index" [index]="i + 1" [college]="college"
    [candidates]="votersByCollege[i]" [unions]="unions" [savedData]="getCollegeCandidatesData(i + 1)"
    [validatedColleges]="validatedColleges" (candidatesChange)="areUnionsComplete()"
    (collegeValidated)="onCollegeValidated($event)" (candidatesData)="onCollegeCandidatesData($event)">
  </app-college-candidates>

  <app-poll-assessors *ngIf="areAllCollegesValidated()" [candidates]="voters" [(assessors)]="assessors"
    [isAssessorsValidated]="areAssessorsValidated" (assessorsValidated)="onAssessorsValidated()"></app-poll-assessors>
</div>

<div class="w-full border-box" *ngIf="!unionValidatedEvent">
  <div *ngFor="let union of tempUnions; let i = index" class="p-20 mt-20 bg-white radius-10">
    <div class="flex content-between mb-20 align-items-center">
      <p class="dark-blue bold no-margin">Créer une liste</p>
      <img class="pointer" (click)="removeUnion(i)" src="assets/trash-gray-icon.svg" alt="trash">
    </div>

    <div class="mb-20 radius-10" style="border: solid 1px #1990FF">
      <div class="flex align-items-center gap-10 p-20" style="border-bottom: solid 1px #E3F2FF">
        <input type="checkbox" name="challenge" [(ngModel)]="union.isCommonUnion"
               (ngModelChange)="onCommonUnionChange($event, i)">
        <div>
          <p class="no-margin light-blue">Cette liste est une liste commune</p>
          <p class="no-margin dark-gray">Pour le calcul de la représentativité uniquement</p>
        </div>
      </div>

      <div class="p-20" *ngIf="union.isCommonUnion">
        <div class="flex content-between">

          <div>
            <p class="bold dark-blue text-md no-margin">Composition de la liste commune</p>
            <p class="dark-gray text-sm">Nombre d'organisations syndicales composant la liste commune</p>
          </div>

          <div class="p-10 radius-10 w-half flex flex-column content-center"
               [style.background-color]="totalPercentage !== 100 ? '#FEF2F2' : '#DCFEE6'"
               [style.border]="totalPercentage !== 100 ? 'solid 1px #FECBCB' : 'solid 1px #63BA67'">
            <p class="no-margin bold text-sm"
               [ngClass]="{ 'strong-red': totalPercentage !== 100, 'dark-blue': totalPercentage === 100 && hasMinimumPercentage }">
              Total des pourcentages : {{totalPercentage}} %</p>
            <p *ngIf="totalPercentage !== 100" class="no-margin strong-red text-sm">
              La somme des pourcentages de la liste commune doit être égale à 100%
            </p>
          </div>
        </div>

        <div class="flex gap-10">
          <input type="number" min="2" max="10" [ngModel]="union.commonUnion.length"
                 (ngModelChange)="onCommonUnionCountChange($event, i)"
                 style="padding: 10px; border-radius: 5px; border: 1px solid #ccc; width: 100px;"
                 (wheel)="$event.preventDefault()">
          <p class="dark-gray text-sm">Minimum : 2 - Maximum : 10</p>
        </div>

        <div class="flex flex-column gap-20 mt-20">
          <div *ngFor="let list of union.commonUnion; let j = index" class="p-20 radius-10"
               style="border: dashed 1px #E2E8F0;">
            <app-union-list [(list)]="union.commonUnion[j]" [index]="j"
                            (listChange)="onUnionChange(i)"></app-union-list>
          </div>

        </div>
      </div>
    </div>

    <div class="flex gap-20">
      <div class="flex flex-column" style="flex: 1;">
        <label class="dark-blue mb-5 text-sm bold">Nom de la liste <span style="color: red;">*</span></label>
        <input type="text" [(ngModel)]="union.shortName" placeholder="Saisissez le nom de la liste"
               (ngModelChange)="onUnionChange(i)"
               [style.border]="isFieldInvalid(i, union.shortName) ? '1px solid red' : '1px solid #ccc'"
               style="padding: 10px; border-radius: 5px;" />
        <p *ngIf="isFieldInvalid(i, union.shortName)" class="no-margin text-sm" style="color: red;">Ce champ est
          obligatoire.</p>
      </div>
      <div *ngIf="!union.isCommonUnion" class="flex flex-column" style="flex: 1;">
        <label *ngIf="!union.isCommonUnion" class="dark-blue mb-5 text-sm bold">
          Nom de l'organisation syndicale d'affiliation du syndicat
        </label>
        <input type="text" [(ngModel)]="union.fullName" placeholder="Saisissez le nom de l'os d'affiliation"
          (ngModelChange)="onUnionChange(i)" style="padding: 10px; border-radius: 5px; border: 1px solid #ccc;" />
      </div>
    </div>

    <div class="flex gap-20 mt-20 mb-20">
      <div class="w-half">
        <p class="bold dark-blue mb-10 text-sm">Logo de l'organisation syndicale</p>
        <div class="flex gap-20 align-items-center p-20 radius-10 pointer" (click)="fileInput1.click()"
          style="border: dotted 1px #1990FF; flex: 1;" (onFileDropped)="onFileChanged($event)">
          <img id="uploaded" class="none" src="" width="20px">
          <img id="upload-image-icon" src="assets/upload-icon.svg" width="20px">
          <div>
            <p class="light-blue no-margin no-margin"><span class="bold">Cliquez</span> pour importer une image</p>
            <input style="display: none" type="file" accept=".jpg,.jpeg,.png" [(ngModel)]="union.logo"
              (ngModelChange)="onUnionChange(i)" (change)="onFileChanged($event.target.files); fileInput1.value=''"
              #fileInput1>
            <p class="grey no-margin text-sm">Format accepté : JPG, JPEG, PNG d'une taille maximale de 2 Mo.</p>
          </div>
        </div>
      </div>

      <div class="w-half">
        <p class="bold dark-blue mb-10 text-sm">Profession de foi de l'organisation syndicale</p>
        <input type="text" [(ngModel)]="union.file" placeholder="Lien vers votre profession de foi"
          class="w-full border-box" (ngModelChange)="onUnionChange(i)"
          style="padding: 10px; border-radius: 5px; border: 1px solid #ccc;" />
      </div>
    </div>

    <div class="mb-20">
      <p class="bold dark-blue no-margin mb-10">Collèges associés <span class="red">*</span></p>
      <div class="flex gap-10 mt-10">
        <label *ngFor="let college of colleges; let coli = index" class="flex align-items-center gap-5">
          <input [attr.name]="'college-' + i + '-' + coli" type="checkbox" [checked]="isCollegeChecked(union, coli)"
            (change)="onCollegeToggle(union, coli, i)">
          <span class="dark-blue">{{ college.collegeName }}</span>
        </label>
      </div>
    </div>


    <button class="bg-light-blue white w-full radius-10 no-border bold" style="padding: 15px 0;"
      [style.opacity]="isUnionValid[i] ? '1' : '0.5'" [style.cursor]="isUnionValid[i] ? 'pointer' : 'not-allowed'"
      [disabled]="!isUnionValid[i]" (click)="isUnionValid[i] && addUnionToList(union, i)">
      Ajouter à la liste syndicale
    </button>
    <!-- <v8te-active-button [buttonText]="'Ajouter à la liste syndicale'" [primaryColor]="'#63BA67'"
      [secondaryColor]="'#63BA67'" [textPrimaryColor]="'#ffffff'" [textSecondaryColor]="'#ffffff'" [border]="'none'"
      [height]="'50'" [minWidth]="'120'" [width]="'240'" [bold]="'true'" [active]="isUnionValid[i]"
      (click)="isUnionValid[i] && unions.push(union) && tempUnions.splice(i, 1)"></v8te-active-button> -->
  </div>
